import { pdf } from "@react-pdf/renderer";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import Swal from 'sweetalert2';
import {
    mostraAlertaError,
    mostraAlertaOk,
    mostraAlertaPersonalizada,
} from "../../../componentes/alerts/sweetAlert";
import { AxiosPrivado, AxiosPublico } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import GestionUbicacion from "../../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../../componentes/googlemap/VerUbicacion";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import Page from "../../../componentes/plantilla/Page";
import Tablas from "../../../componentes/tablas/TablasGenerico";
import {
    CotizacionesEditar,
    CotizacionesFiltro,
    ImagenProducto,
    PedidosGuardar,
    CotizacionId
} from "../../../configuracion/apiUrls";
import { DireccionConfig } from "../../../configuracion/Empresa";
import { formatoMoneda } from "../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import ModalProductosWizard from "./editar/ModalProducto";
import { ImprimirCotizacion } from "./imprimir/ImprimirCotizacion";
import ReporteCotizacion from "./imprimir/ReporteCotizacion";
import { IdentificarEstacion } from "../../../componentes/estacion/Estacion";
import { ErroresPeticion } from "../../../componentes/axios/ErroresPeticion";

moment.locale("es");

const calcularPrecioFinalConTodo = (datosProducto, cantidad, selectedLote = null) => {
    let precioFinal;
    let esMayoreoAplicado = false;

    if (selectedLote && selectedLote.precio) {
        precioFinal = parseFloat(selectedLote.precio);
    } else {
        precioFinal = parseFloat(datosProducto.precio) || 0;
    }

    let precioOriginalProducto = precioFinal;

    if (selectedLote && selectedLote.loteprecios && selectedLote.loteprecios.length > 0) {
        const nivelesMayoreoOrdenadosLote = [...selectedLote.loteprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenadosLote) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }
    else if (!selectedLote && datosProducto.productoprecios && datosProducto.productoprecios.length > 0) {
        const nivelesMayoreoOrdenados = [...datosProducto.productoprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenados) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }

    return {
        price: precioFinal.toFixed(2),
        precioOriginalProducto: precioOriginalProducto.toFixed(2),
        esMayoreoAplicado,
    };
};

const EditarCotizacion = () => {
    const { usuario, estacion } = useContextUsuario();
    const [cotizaciones, setCotizaciones] = useState([]);
    const [cotizacionSeleccionada, setCotizacionSeleccionada] = useState(null);
    const [productos, setProductos] = useState([]);
    const [detallesEdicion, setDetallesEdicion] = useState([]);
    const [notaNueva, setNotaNueva] = useState("");
    const [productoSeleccionadoIndex, setProductoSeleccionadoIndex] = useState(null);
    const [fechaInicio, setFechaInicio] = useState(
        moment().subtract(1, "days").format("YYYY-MM-DD")
    );
    const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
    const [incluirEmpleado, setIncluirEmpleado] = useState(true);
    const [selectedEvent, setSelectedEvent] = useState({});
    const { listaProductos, listaClientes } = useContextEmpleado();
    const refEdicion = useRef(null);
    const topRef = useRef(null);
    const [estadoFiltro, setEstadoFiltro] = useState("");
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalClienteOpen, setModalClienteOpen] = useState(false);
    const [clienteSearchTerm, setClienteSearchTerm] = useState("");
    const clientes = listaClientes || [];
    const [clienteId, setClienteId] = useState("");
    const [empleadoId, setEmpleadoId] = useState("");
    const [nuevaDireccion, setNuevaDireccion] = useState({
        direccion: DireccionConfig.direccion,
        longitud: DireccionConfig.longitud,
        latitud: DireccionConfig.latitud,
    });
    const [direccionesEdicion, setDireccionesEdicion] = useState([]);
    const [modalWizardOpen, setModalWizardOpen] = useState(false);

    const datos = {
        titulo: {
            titulo: "Edición de cotizaciones",
            url: "/app/clientes/cotizaciones/editar",
            tituloUrl: "Cotizaciones",
            nombreUrl: "Ver cotizaciones",
        },
    };

    const esPromocionActiva = (promo) => {
        if (!promo || promo.estado !== "Activo") return false;

        const ahora = new Date();
        const hoyStr = ahora.toISOString().slice(0, 10);
        const horaActual = ahora.toTimeString().slice(0, 5);
        const diaSemana = ahora.toLocaleString('es-HN', { weekday: 'long' }).toLowerCase();

        if (hoyStr < promo.fechaInicio || hoyStr > promo.fechaFin) return false;

        if (promo.diasSemana) {
            const dias = promo.diasSemana.toLowerCase().split(',').map(d => d.trim());
            if (!dias.includes("todos") && !dias.includes(diaSemana)) return false;
        }

        if (promo.hora_inicio && promo.hora_fin) {
            const hi = promo.hora_inicio.slice(0, 5);
            const hf = promo.hora_fin.slice(0, 5);
            if (horaActual < hi || horaActual > hf) return false;
        }

        return true;
    };

    const transformarProductos = (listaProductos) =>
        Array.isArray(listaProductos) && listaProductos.length > 0
            ? listaProductos.map((p) => {
                const precioBase = parseFloat(p.precio) || 0;

                let promoActiva = null;

                if (Array.isArray(p.detallepromocions)) {
                    for (const detalle of p.detallepromocions) {
                        if (esPromocionActiva(detalle.promocion)) {
                            promoActiva = detalle;
                            break;
                        }
                    }
                }

                const tienePromocion = Boolean(promoActiva);
                const precioFinal = tienePromocion
                    ? parseFloat(promoActiva.precioPromocion)
                    : precioBase;

                return {
                    id: p.id,
                    nombre: p.nombre,
                    descripcion: p.descripcion,
                    precio: precioFinal.toFixed(2),
                    precioOriginal: tienePromocion ? precioBase.toFixed(2) : null,
                    porcentajeDescuento: tienePromocion
                        ? promoActiva.promocion.descuento
                        : null,
                    nombrePromocion: tienePromocion
                        ? promoActiva.promocion.nombre
                        : null,
                    existencia: p.existencia,
                    codigo: p.codigo,
                    imagen: p.productoImagens?.[0]?.imagen
                        ? ImagenProducto + p.productoImagens[0].imagen
                        : "/productos.jpg",
                    tienePromocion,
                    lotes: p.lotes || [],
                };
            })
            : [];

    const fetchCotizacionesCliente = async () => {
        try {
            const params = new URLSearchParams();
            if (selectedEvent.clienteId) params.append("clienteId", selectedEvent.clienteId);
            if (incluirEmpleado && usuario.datoPersonales.id) {
                params.append("empleadoId", usuario.datoPersonales.id);
            }
            if (fechaInicio) params.append("fechaInicio", moment(fechaInicio).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
            if (fechaFin) params.append("fechaFin", moment(fechaFin).endOf('day').format('YYYY-MM-DD HH:mm:ss'));

            const response = await AxiosPublico.get(`${CotizacionesFiltro}?${params.toString()}`);

            if (Array.isArray(response.data)) {
                let cotizacionesFiltradas = response.data;

                if (estadoFiltro) {
                    cotizacionesFiltradas = cotizacionesFiltradas.filter(cotizacion => cotizacion.estado === estadoFiltro);
                }

                const transformados = cotizacionesFiltradas.map((cotizacion) => ({
                    id: cotizacion.id,
                    fechaOriginal: cotizacion.fecha,
                    fecha: moment(cotizacion.fecha).format("YYYY-MM-DD HH:mm"),
                    estado: cotizacion.estado,
                    envio: cotizacion.envio,
                    notas: cotizacion.notas || "Sin nota",
                    total: cotizacion.cotizacionDetalles
                        ?.reduce(
                            (sum, item) =>
                                sum + parseFloat(item.precio || 0) * (item.cantidad || 1),
                            0
                        )
                        .toFixed(2),
                    Cliente: cotizacion.Cliente,
                    Empleado: cotizacion.Empleado,
                    nombreCliente: cotizacion.Cliente?.nombreCompleto || "Sin nombre",
                    nombreEmpleado: cotizacion.Empleado?.nombreCorto || "Sin empleado",
                    clienteId: cotizacion.clienteId,
                    empleadoId: cotizacion.empleadoId,
                    detalles: cotizacion.cotizacionDetalles?.map((detalle) => ({
                        id: detalle.id,
                        productoId: detalle.producto?.id || null,
                        nombre: detalle.producto?.nombre || "Producto no especificado",
                        cantidad: detalle.cantidad || 1,
                        precio: parseFloat(detalle.precio || 0).toFixed(2),
                        subtotal: (detalle.cantidad * parseFloat(detalle.precio)).toFixed(2),
                        lote: detalle.lote,
                        loteinventario: detalle.loteinventario,
                        inventarioTipo: detalle.inventarioTipo,

                    })),
                    direcciones: cotizacion.CotizacionDireccions?.map((direccion) => ({
                        id: direccion.id,
                        direccion: direccion.direccion,
                        longitud: direccion.longitud || null,
                        latitud: direccion.latitud || null
                    })) || []
                }));

                transformados.sort((a, b) =>
                    moment(b.fechaOriginal).valueOf() - moment(a.fechaOriginal).valueOf()
                );

                setCotizaciones(transformados);
            }
        } catch (error) {
            mostraAlertaError("Error al obtener las cotizaciones filtradas.", "Error");
        }
    };

    useEffect(() => {
        if (seleccionarDireccion) {
            setIsModalOpen(false);
            if (direccionesEdicion.length >= 1) {
                mostraAlertaError("Solo se permite una dirección por cotización.", "Límite alcanzado");
            } else {
                setDireccionesEdicion((prev) => [...prev, nuevaDireccion]);
            }
            setSeleccionarDireccion(false);
        }
    }, [seleccionarDireccion, nuevaDireccion, direccionesEdicion]);

    const handleFiltrar = () => {
        fetchCotizacionesCliente();
        setPanelAbierto(false);
    };

    const handleReset = () => {
        setFechaInicio(moment().format("YYYY-MM-DD"));
        setFechaFin(moment().format("YYYY-MM-DD"));
        setClienteId("");
        setIncluirEmpleado(false);
        setEstadoFiltro("");
        setSelectedEvent({});
        fetchCotizacionesCliente();
        setPanelAbierto(false);
    };

    const handleEditar = (cotizacionId) => {
        const cotizacion = cotizaciones.find((p) => p.id === cotizacionId);
        if (!cotizacion) return;
        if (cotizacion.estado === "Programada" && cotizacion.envio !== "Pendiente" && cotizacion.envio !== "Sin Envio") {
            mostraAlertaError(
                "Esta cotización ya está programada y no se puede editar.",
                "Acción no permitida"
            );
            return;
        }

        if (cotizacion.estado === "Completada") {
            mostraAlertaError(
                "Esta cotización ya fue completada y no se puede editar.",
                "Acción no permitida"
            );
            return;
        }

        if (cotizacion.estado === "Cancelada") {
            mostraAlertaError(
                "Esta cotización ya fue cancelada y no se puede editar.",
                "Acción no permitida"
            );
            return;
        }

        if (cotizacionSeleccionada === cotizacionId) {
            setCotizacionSeleccionada(null);
        } else {
            setCotizacionSeleccionada(cotizacionId);
            setDetallesEdicion(cotizacion.detalles);
            setDireccionesEdicion(cotizacion.direcciones || []);
            setNotaNueva(cotizacion.notas);
        }
    };

    useEffect(() => {
        if (cotizacionSeleccionada && refEdicion.current) {
            refEdicion.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [cotizacionSeleccionada]);

    const handleCancelar = (cotizacionId) => {
        const cotizacion = cotizaciones.find((p) => p.id === cotizacionId);
        if (!cotizacion) return;

        if (cotizacion.estado === "Completada") {
            mostraAlertaError(
                "Esta cotización ya fue completada y no se puede cancelar.",
                "Acción no permitida"
            );
            return;
        }

        if (cotizacion.estado !== "Programada") {
            if (cotizacion.estado !== "Pendiente") {
                mostraAlertaError(
                    "Solo se pueden cancelar cotizaciones en estado 'Pendiente'.",
                    "Acción no permitida"
                );
                return;
            }
        }

        if (cotizacion.envio === "Enviado") {
            mostraAlertaError(
                "Esta cotización ya fue enviada y no se puede cancelar.",
                "Acción no permitida"
            );
            return;
        }

        if (cotizacion.envio === "Entregado") {
            mostraAlertaError(
                "Esta cotización ya fue entregada y no se puede cancelar.",
                "Acción no permitida"
            );
            return;
        }

        confirmarAccion(cotizacionId, "Cancelar");
    };

    const handleImprimir = async (cotizacionId) => {
        Swal.fire({
            title: 'Generando PDF...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const cotizacion = cotizaciones.find(c => c.id === cotizacionId);

        const detallesAImprimir = cotizacion?.detalles || cotizacion?.cotizacionDetalles;

        if (cotizacion && detallesAImprimir && detallesAImprimir.length > 0) {
            let subtotal = 0;
            let isv = 0;
            let total = 0;

            const detallesParaReporte = detallesAImprimir.map(item => {
                const productoObjeto = item.producto || {
                    id: item.productoId,
                    nombre: item.nombre,
                    precioSinImpuesto: parseFloat(item.precioSinImpuesto) || parseFloat(item.precio) / 1.15,
                    precioConImpuesto: parseFloat(item.precioConImpuesto) || parseFloat(item.precio),
                };

                return {
                    ...item,
                    producto: productoObjeto,
                };
            });

            detallesParaReporte.forEach(item => {
                const cantidad = parseFloat(item.cantidad) || 0;

                const precioFinalUnitario = parseFloat(item.precio) || 0;
                const precioBase = parseFloat(item.producto.precioSinImpuesto) || precioFinalUnitario;
                const impuestoUnitario = (parseFloat(item.producto.precioConImpuesto) || 0) - (parseFloat(item.producto.precioSinImpuesto) || 0);

                subtotal += cantidad * precioBase;
                isv += cantidad * impuestoUnitario;
                total += cantidad * precioFinalUnitario;
            });

            const cotizacionCompleta = {
                ...cotizacion,
                cotizacionDetalles: detallesParaReporte,
                subtotal: subtotal.toFixed(2),
                isv: isv.toFixed(2),
                total: total.toFixed(2),
            };

            try {
                const blob = await pdf(<ReporteCotizacion cotizacion={cotizacionCompleta} />).toBlob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Cotizacion_${cotizacionCompleta.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                Swal.close();
            } catch (error) {
                Swal.close();
                mostraAlertaError("Error al generar el PDF. Inténtelo de nuevo.");
            }
        } else {
            Swal.close();
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
        }
    };

    const handleImprimirCotizacion = async (id) => {
        try {
            const response = await AxiosPrivado.get(CotizacionId + id);
            const cotizacion = response.data;
            ImprimirCotizacion(cotizacion);
        } catch (error) {
            ErroresPeticion(error);
        }
    };

    const handleRealizarPedido = async (cotizacionId) => {
        const cotizacion = cotizaciones.find((c) => c.id === cotizacionId);

        if (!cotizacion) {
            mostraAlertaError("Cotización no encontrada.", "Error");
            return;
        }

        Swal.fire({
            title: '¿Estás seguro?',
            text: '¿Deseas convertir esta cotización en un pedido?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, crear pedido',
            cancelButtonText: 'No, cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const tieneDireccion = cotizacion.direcciones && cotizacion.direcciones.length > 0;
                    const envio = tieneDireccion ? "Pendiente" : "Sin envío";
                    const payload = {
                        fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
                        estado: "Pendiente",
                        notas: cotizacion.notas || "Pedido generado de cotización",
                        clienteId: cotizacion.clienteId,
                        empleadoId: cotizacion.empleadoId || 1,
                        envio,
                        detalles: cotizacion.detalles.map((detalle) => ({
                            cantidad: parseInt(detalle.cantidad, 10),
                            precio: parseFloat(detalle.precio),
                            productoId: detalle.productoId,
                            loteId: detalle.lote?.id,
                            loteInventarioId: detalle.loteinventario?.id
                        })),
                        direcciones: tieneDireccion ? cotizacion.direcciones.map((dir) => ({
                            direccion: dir.direccion,
                            latitud: dir.latitud,
                            longitud: dir.longitud
                        })) : [],
                        estacionDatos: estacion
                    };
                    await AxiosPublico.post(PedidosGuardar, payload);
                    mostraAlertaOk("Pedido creado exitosamente a partir de la cotización.", "Éxito");
                    fetchCotizacionesCliente();
                    setCotizacionSeleccionada(null);

                } catch (error) {
                    console.error("Error al crear el pedido:", error);
                    mostraAlertaError("Error al crear el pedido. Inténtalo de nuevo.", "Error");
                }
            }
        });
    };

    const columnas2 = useMemo(
        () => [
            {
                title: "Id",
                data: "id"
            },
            {
                title: "Cliente",
                data: "nombreCliente"
            },
            {
                title: "Productos",
                data: "detalles",
                render: (data) => {
                    if (!data || data.length === 0) {
                        return "Sin productos";
                    }
                    const primerProducto = data[0].nombre;
                    if (data.length === 1) {
                        return primerProducto;
                    }
                    const productosRestantes = data.length - 1;
                    return `${primerProducto} (+${productosRestantes} más)`;
                }
            },
            {
                title: "Fecha",
                data: "fecha",
                render: (data, type, rowData) => {
                    if (type === 'sort') {
                        return moment(rowData.fechaOriginal).valueOf();
                    }

                    if (!data) return "";

                    const date = new Date(data);
                    const formattedDate = date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
                    const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: true });
                    return `${formattedDate}<br>${formattedTime}`;
                }
            },
            {
                title: "Estado y Envío",
                data: null,
                render: (data, type, rowData) => {
                    let estadoBadgeClass = "";
                    if (rowData.estado === "Pendiente") estadoBadgeClass = "bg-warning";
                    else if (rowData.estado === "Programada") estadoBadgeClass = "bg-success";
                    else if (rowData.estado === "Completada") estadoBadgeClass = "bg-primary";
                    else if (rowData.estado === "Cancelada") estadoBadgeClass = "bg-danger";

                    let envioBadgeClass = "";
                    if (rowData.envio === "Pendiente") envioBadgeClass = "bg-warning";
                    else if (rowData.envio === "Enviado") envioBadgeClass = "bg-success";
                    else if (rowData.envio === "Entregado") envioBadgeClass = "bg-primary";
                    else if (rowData.envio === "Sin Envio") envioBadgeClass = "bg-secondary";

                    const estadoSpan = `<span class="badge ${estadoBadgeClass}">${rowData.estado}</span>`;
                    const envioSpan = `<span class="badge ${envioBadgeClass}">${rowData.envio}</span>`;

                    return `${estadoSpan}<br>${envioSpan}`;
                },
            },
            { title: "Total (L)", data: "total" },
            {
                title: "Acciones",
                data: null,
                orderable: false,
                actions: [
                    {
                        key: "editar",
                        className: "btn btn-outline-primary btn-sm",
                        icon: "fas fa-edit",
                        title: "Editar",
                        onClick: (rowData) => handleEditar(rowData.id)
                    },
                    {
                        key: "cancelar",
                        className: "btn btn-outline-danger btn-sm",
                        icon: "fas fa-trash",
                        title: "Cancelar",
                        onClick: (rowData) => handleCancelar(rowData.id)
                    },
                    {
                        key: "realizar pedido",
                        className: "btn btn-outline-warning btn-sm",
                        icon: "fa-solid fa-file-export",
                        title: "HacerPedido",
                        onClick: (rowData) => handleRealizarPedido(rowData.id)
                    },
                    {
                        key: "imprimirCotizacion",
                        className: "btn btn-outline-info btn-sm",

                        icon: "fas fa-print",
                        title: "Imprimir",
                        onClick: (rowData) => handleImprimirCotizacion(rowData.id)
                    },
                    {
                        key: "Reporte",
                        className: "btn btn-outline-success btn-sm",
                        icon: "fas fa-chart-bar",
                        title: "Imprimir",
                        onClick: (rowData) => handleImprimir(rowData.id)
                    },
                ]
            }
        ],
        [cotizaciones, handleEditar, handleCancelar, handleImprimir, handleImprimirCotizacion, handleRealizarPedido]
    );

    useEffect(() => {
        fetchCotizacionesCliente();
    }, [empleadoId, fechaInicio, fechaFin, clienteId, incluirEmpleado]);

    useEffect(() => {
        const productosTransformados = transformarProductos(listaProductos);
        setProductos(productosTransformados);
    }, [listaProductos]);

    const confirmarAccion = async (cotizacionId, accion) => {
        const mensaje =
            accion === "Cancelar"
                ? "¿Estás seguro de cancelar esta cotización?"
                : "¿Deseas guardar los cambios en esta cotización?";

        mostraAlertaPersonalizada({
            titulo: "Confirmación requerida",
            mensaje,
            icono: accion === "Cancelar" ? "warning" : "question",
            textoConfirmacion: accion === "Cancelar" ? "Sí, cancelar" : "Guardar cambios",
            textoCancelacion: "Regresar",
            accion: async (confirmado) => {
                if (confirmado) {
                    const tieneDireccion = direccionesEdicion.length > 0;
                    const cotizacionOriginal = cotizaciones.find((p) => p.id === cotizacionId);

                    if (!cotizacionOriginal) {
                        return mostraAlertaError("Cotización original no encontrada.", "Error de datos");
                    }

                    if (tieneDireccion && direccionesEdicion.length > 1) {
                        return mostraAlertaError("Solo se permite una dirección por cotización.", "Límite alcanzado");
                    }

                    const envio = tieneDireccion ? "Pendiente" : "Sin envío";

                    const payload = {
                        fecha: cotizacionOriginal.fecha,
                        estado: accion === "Cancelar" ? "Cancelada" : "Pendiente",
                        notas: notaNueva || "Sin notas adicionales",
                        empleadoId: usuario.datoPersonales.id,
                        clienteId: cotizacionOriginal.clienteId,
                        envio,
                        detalles: detallesEdicion.map((detalle) => ({
                            cantidad: parseInt(detalle.cantidad, 10),
                            precio: parseFloat(detalle.precio),
                            productoId: detalle.productoId,
                            loteId: detalle.lote?.id,
                            loteInventarioId: detalle.loteinventario?.id
                        })),
                        direcciones: tieneDireccion
                            ? direccionesEdicion.map((dir) => ({
                                direccion: dir.direccion,
                                latitud: dir.latitud,
                                longitud: dir.longitud
                            }))
                            : []
                    };

                    try {
                        await AxiosPublico.put(`${CotizacionesEditar}?id=${cotizacionId}`, payload);
                        mostraAlertaOk(
                            accion === "Cancelar"
                                ? "Cotización cancelada correctamente."
                                : "Cotización actualizada correctamente.",
                            "Éxito"
                        );
                        fetchCotizacionesCliente();
                        setCotizacionSeleccionada(null);
                        setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }, 100);
                    } catch (error) {
                        mostraAlertaError("Error al realizar la acción. Inténtalo de nuevo.", "Error");
                    }
                }
            },
        });
    };

    const handleCambiarProducto = (index) => {
        setProductoSeleccionadoIndex(index);
        setModalWizardOpen(true);
    };

    const seleccionarProductoParaReemplazar = (productoAgregado) => {
        setDetallesEdicion((prev) => {
            const nuevosDetalles = [...prev];
            if (productoSeleccionadoIndex !== null) {
                const precioFinal = parseFloat(productoAgregado.price);
                nuevosDetalles[productoSeleccionadoIndex] = {
                    ...nuevosDetalles[productoSeleccionadoIndex],
                    productoId: productoAgregado.id,
                    nombre: productoAgregado.nombre,
                    cantidad: productoAgregado.cantidad,
                    precio: precioFinal,
                    subtotal: (productoAgregado.cantidad * precioFinal).toFixed(2),
                    lote: productoAgregado.loteSeleccionado,
                    loteinventario: productoAgregado.loteInventarioSeleccionado,
                    esMayoreoAplicado: productoAgregado.esMayoreoAplicado,
                    precioOriginalProducto: productoAgregado.precioOriginalProducto
                };
            }
            return nuevosDetalles;
        });
        setModalWizardOpen(false);
        setProductoSeleccionadoIndex(null);
    };

    const handleEliminarProducto = (index) => {
        const nuevosDetalles = [...detallesEdicion];
        nuevosDetalles.splice(index, 1);
        setDetallesEdicion(nuevosDetalles);
    };

    const agregarProductoAlPedido = (productoAgregado) => {
        setDetallesEdicion((prev) => {
            if (productoSeleccionadoIndex !== null) {
                const nuevos = [...prev];
                const nuevaCantidad = parseInt(productoAgregado.cantidad, 10);
                const productoCompleto = listaProductos.find(p => p.id === productoAgregado.id);
                const detallesPrecio = calcularPrecioFinalConTodo(
                    productoCompleto,
                    nuevaCantidad,
                    productoAgregado.loteSeleccionado
                );

                nuevos[productoSeleccionadoIndex] = {
                    id: productoAgregado.id,
                    productoId: productoAgregado.id,
                    nombre: productoAgregado.nombre,
                    cantidad: nuevaCantidad,
                    precio: detallesPrecio.price,
                    subtotal: (nuevaCantidad * parseFloat(detallesPrecio.price)).toFixed(2),
                    lote: productoAgregado.loteSeleccionado,
                    loteinventario: productoAgregado.loteInventarioSeleccionado,
                    esMayoreoAplicado: detallesPrecio.esMayoreoAplicado,
                    precioOriginalProducto: detallesPrecio.precioOriginalProducto
                };
                setProductoSeleccionadoIndex(null);
                return nuevos;
            } else {
                const productoExistente = prev.find(
                    (item) =>
                        item.productoId === productoAgregado.id &&
                        (item.lote?.id || null) === (productoAgregado.loteSeleccionado?.id || null) &&
                        (item.loteinventario?.id || null) === (productoAgregado.loteInventarioSeleccionado?.id || null)
                );

                const precioFinal = parseFloat(productoAgregado.price);

                if (productoExistente) {
                    return prev.map((item) =>
                        item.productoId === productoAgregado.id &&
                            (item.lote?.id || null) === (productoAgregado.loteSeleccionado?.id || null) &&
                            (item.loteinventario?.id || null) === (productoAgregado.loteInventarioSeleccionado?.id || null)
                            ? {
                                ...item,
                                cantidad: item.cantidad + productoAgregado.cantidad,
                                subtotal: ((item.cantidad + productoAgregado.cantidad) * precioFinal).toFixed(2),
                            }
                            : item
                    );
                } else {
                    return [
                        ...prev,
                        {
                            productoId: productoAgregado.id,
                            nombre: productoAgregado.nombre,
                            cantidad: productoAgregado.cantidad,
                            precio: precioFinal,
                            subtotal: (productoAgregado.cantidad * precioFinal).toFixed(2),
                            lote: productoAgregado.loteSeleccionado,
                            loteinventario: productoAgregado.loteInventarioSeleccionado,
                            esMayoreoAplicado: productoAgregado.esMayoreoAplicado,
                            precioOriginalProducto: productoAgregado.precioOriginalProducto
                        },
                    ];
                }
            }
        });
        setModalWizardOpen(false);
    };

    const cotizacionActual = cotizaciones.find(p => p.id === cotizacionSeleccionada);
    const envio = cotizacionActual?.envio || "";
    const puedeGestionarDireccion =
        envio.trim().toLowerCase() !== "sin envío";

    const totalCotizacion = useMemo(() => {
        return detallesEdicion.reduce((sum, item) => {
            return sum + (parseFloat(item.precio) * item.cantidad);
        }, 0).toFixed(2);
    }, [detallesEdicion]);

    const filteredClientes = clientes.filter((cliente) => {
        const searchTerm = clienteSearchTerm.trim().toLowerCase();

        // 1. Búsqueda por Nombre Completo del Cliente
        const nombreClienteMatch = cliente.nombreCompleto
            .toLowerCase()
            .includes(searchTerm);

        // 2. Búsqueda por Nombre de la Empresa del Cliente
        const nombreEmpresaMatch =
            cliente.ClienteEmpresas &&
            cliente.ClienteEmpresas.some((empresa) =>
                empresa.nombre.toLowerCase().includes(searchTerm)
            );

        // El cliente se incluye si coincide por nombre completo O por el nombre de alguna de sus empresas
        return nombreClienteMatch || nombreEmpresaMatch;
    });

    const handleClienteSeleccionado = (cliente) => {
        setSelectedEvent((prev) => ({
            ...prev,
            clienteId: cliente.id,
            clienteNombre: cliente.nombreCompleto,
        }));
        setModalClienteOpen(false);
    };

    const [paginaCliente, setPaginaCliente] = useState(1);
    const clientesPorPagina = 5;
    const indexUltimoCliente = paginaCliente * clientesPorPagina;
    const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
    const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
    const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);

    return (
        <Page datos={datos}>
            <div ref={topRef} />
            <Card>
                <div className="mb-4 d-flex justify-content-end">
                    <div className="position-relative">
                        <button
                            className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                            onClick={() => setPanelAbierto(!panelAbierto)}
                            style={{
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "0.9rem",
                                minWidth: "140px",
                            }}
                        >
                            <span className="d-flex align-items-center">
                                <i className="fas fa-filter mx-2"></i>
                                Filtros
                            </span>
                            <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                        </button>

                        {panelAbierto && (
                            <div
                                className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                                style={{
                                    minWidth: "240px",
                                    right: 0,
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    padding: "15px",
                                    zIndex: 1050,
                                    border: "1px solid red",
                                }}
                            >
                                <div className="mb-3">
                                    <label className="form-label">Fecha inicio</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaInicio}
                                        onChange={(e) => setFechaInicio(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fecha fin</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaFin}
                                        onChange={(e) => setFechaFin(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Cliente</label>
                                    <div className="d-flex align-items-center">
                                        {selectedEvent.clienteNombre ? (
                                            <span className="text-success fw-bold">{selectedEvent.clienteNombre}</span>
                                        ) : (
                                            <span className="text-muted">Ninguno seleccionado</span>
                                        )}
                                    </div>
                                    <ModalBootstrap
                                        titulo="Seleccionar cliente"
                                        nombreBoton="Buscar"
                                        estiloBoton="btn btn-sm btn-outline-primary mt-2"
                                        iconBoton="fa-solid fa-magnifying-glass"
                                        modalIsOpen={modalClienteOpen}
                                        setModalIsOpen={setModalClienteOpen}
                                    >
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar cliente..."
                                                value={clienteSearchTerm}
                                                onChange={(e) => setClienteSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped table-hover shadow-smr">
                                                <thead className="bg-dark text-white">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Empresas</th>
                                                        <th>Nombre completo</th>
                                                        <th>Agregar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientesPagina.length > 0 ? (
                                                        clientesPagina.map((cliente) => (
                                                            <tr key={cliente.id}>
                                                                <td>{cliente.id}</td>
                                                                <td className="align-middle">
                                                                    {cliente.ClienteEmpresas && cliente.ClienteEmpresas.length > 0
                                                                        ? cliente.ClienteEmpresas.map((empresa, index) => (
                                                                            <div key={index} className="mb-1">
                                                                                {empresa.nombre}
                                                                            </div>
                                                                        ))
                                                                        : "N/A"}
                                                                </td>
                                                                <td>{cliente.nombreCompleto}</td>
                                                                <td className="text-center align-middle">
                                                                    <button
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() =>
                                                                            handleClienteSeleccionado(cliente)
                                                                        }
                                                                    >
                                                                        <i className="fa-regular fa-square-check" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted">
                                                                No se encontraron clientes.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="d-flex justify-content-center">
                                                <nav className="mt-2">
                                                    <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                                        <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente - 1)}
                                                                aria-label="Anterior"
                                                            >
                                                                <i className="fas fa-chevron-left me-1"></i> Anterior
                                                            </button>
                                                        </li>

                                                        {
                                                            (() => {
                                                                const pagesToShow = 5;
                                                                const halfPages = Math.floor(pagesToShow / 2);
                                                                let startPage = Math.max(1, paginaCliente - halfPages);
                                                                let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                                                                if (paginaCliente <= halfPages) {
                                                                    endPage = Math.min(totalPaginasCliente, pagesToShow);
                                                                }
                                                                if (paginaCliente > totalPaginasCliente - halfPages) {
                                                                    startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                                                                }

                                                                const pageButtons = [];
                                                                for (let i = startPage; i <= endPage; i++) {
                                                                    pageButtons.push(
                                                                        <li
                                                                            key={i}
                                                                            className={`page-item ${paginaCliente === i ? "active" : ""}`}
                                                                        >
                                                                            <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                                                                {i}
                                                                            </button>
                                                                        </li>
                                                                    );
                                                                }
                                                                return pageButtons;
                                                            })()
                                                        }

                                                        <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente + 1)}
                                                                aria-label="Siguiente"
                                                            >
                                                                Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </ModalBootstrap>
                                </div>
                                <div className="form-check mb-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="incluirEmpleado"
                                        checked={incluirEmpleado}
                                        onChange={() => setIncluirEmpleado(!incluirEmpleado)}
                                    />
                                    <label className="form-check-label ms-2" htmlFor="incluirEmpleado">
                                        Solo mis cotizaciones
                                    </label>
                                </div>
                                <div className="form-group me-2 mb-3">
                                    <label htmlFor="estadoFiltro">Estado</label>
                                    <select
                                        id="estadoFiltro"
                                        className="form-control form-control-sm"
                                        value={estadoFiltro}
                                        onChange={(e) => setEstadoFiltro(e.target.value)}
                                    >
                                        <option value="">Todos</option>
                                        <option value="Pendiente">Pendiente</option>
                                        <option value="Programada">Programada</option>
                                        <option value="Completada">Completada</option>
                                        <option value="Cancelada">Cancelada</option>
                                    </select>
                                </div>
                                <div className="d-flex">
                                    <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                        <i className="fas fa-filter mx-1"></i> Filtrar
                                    </button>
                                    <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                        <i className="fas fa-sync-alt mx-1"></i> Reset
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Tablas datos={cotizaciones} columnas={columnas2} id="tablaCotizaciones" />
            </Card>
            {cotizacionSeleccionada && (
                <div ref={refEdicion}>
                    <Card titulo="Detalles de la cotización" className="p-3 shadow-lg rounded"
                        pie={<>
                            <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                                <button
                                    className="btn btn-success"
                                    onClick={() => confirmarAccion(cotizacionSeleccionada, "Guardar")}
                                > Guardar
                                    <i className="fas fa-save me-2 mx-2"></i>
                                </button>
                                <ModalProductosWizard
                                    modalIsOpen={modalWizardOpen}
                                    setModalIsOpen={setModalWizardOpen}
                                    listaProductos={listaProductos}
                                    agregarAlCarrito={productoSeleccionadoIndex !== null ? seleccionarProductoParaReemplazar : agregarProductoAlPedido}
                                    isReplaceMode={productoSeleccionadoIndex !== null}
                                    initialProductData={productoSeleccionadoIndex !== null ? detallesEdicion[productoSeleccionadoIndex] : null}
                                />
                            </div>
                        </>
                        }>
                        <div className="d-flex flex-column gap-3">
                            {detallesEdicion.map((detalle, index) => {
                                const productoDeLista = listaProductos.find(p => p.id === detalle.productoId);
                                const productoParaCalculo = productoDeLista || {
                                    ...detalle,
                                    precio: detalle.precioOriginalProducto || detalle.precio,
                                    lote: detalle.lote,
                                    detallepromocions: [],
                                };

                                return (
                                    <div className="card shadow-sm" key={detalle.id || index}>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <div className="d-flex flex-column text-start">
                                                    <h5 className="card-title mb-0 fw-bold fs-6 fs-md-5">{detalle.nombre}</h5>
                                                    {detalle.lote && (
                                                        <div className="small text-muted text-truncate" style={{ maxWidth: '180px' }}>
                                                            Lote: {detalle.lote.nombre_lote}
                                                        </div>
                                                    )}
                                                    {detalle.loteinventario && (
                                                        <div className="small text-muted text-truncate" style={{ maxWidth: '180px' }}>
                                                            Inventario: {detalle.loteinventario.inventarioTipo?.nombre}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="d-flex gap-2 align-items-center">
                                                    <button
                                                        className="btn btn-sm btn-info d-flex align-items-center justify-content-center mx-2"
                                                        onClick={() => handleCambiarProducto(index)}
                                                        title="Cambiar Producto"
                                                        style={{ width: '36px', height: '36px' }}
                                                    >
                                                        <i className="fas fa-exchange-alt"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                                        onClick={() => handleEliminarProducto(index)}
                                                        title="Eliminar Producto"
                                                        style={{ width: '36px', height: '36px' }}
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="row g-2 mb-3">
                                                <div className="col-12">
                                                    <p className="mb-1 text-muted">Precios por cantidad:</p>
                                                    {detalle.lote?.loteprecios?.length > 0 ? (
                                                        <ul className="list-unstyled small mb-0">
                                                            {detalle.lote.loteprecios
                                                                .sort((a, b) => a.cantidad - b.cantidad)
                                                                .map((p, i) => (
                                                                    <li key={i}>{p.cantidad}+ unid: {formatoMoneda(p.precio)}</li>
                                                                ))
                                                            }
                                                        </ul>
                                                    ) : (
                                                        <span className="text-muted small">N/A</span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="row g-3 align-items-center mb-3">
                                                <div className="col-auto">
                                                    <label htmlFor={`cantidad-${index}`} className="col-form-label text-muted">Cantidad:</label>
                                                </div>
                                                <div className="col">
                                                    <input
                                                        id={`cantidad-${index}`}
                                                        type="number"
                                                        className="form-control form-control-sm text-center"
                                                        style={{ width: "90px" }}
                                                        value={detalle.cantidad}
                                                        min="1"
                                                        onChange={(e) =>
                                                            setDetallesEdicion((prev) => {
                                                                const nuevos = [...prev];
                                                                const nuevaCantidad = parseInt(e.target.value) || 1;

                                                                const productoActualParaCalculo = listaProductos.find(p => p.id === nuevos[index].productoId) || {
                                                                    ...nuevos[index],
                                                                    precio: parseFloat(nuevos[index].precioOriginalProducto || nuevos[index].precio),
                                                                    detallepromocions: [],
                                                                    lote: nuevos[index].lote
                                                                };

                                                                const detallesPrecio = calcularPrecioFinalConTodo(
                                                                    productoActualParaCalculo,
                                                                    nuevaCantidad,
                                                                    nuevos[index].lote
                                                                );

                                                                nuevos[index].cantidad = nuevaCantidad;
                                                                nuevos[index].precio = detallesPrecio.price;
                                                                nuevos[index].subtotal = (nuevaCantidad * parseFloat(detallesPrecio.price)).toFixed(2);
                                                                nuevos[index].esMayoreoAplicado = detallesPrecio.esMayoreoAplicado;
                                                                nuevos[index].precioOriginalProducto = detallesPrecio.precioOriginalProducto;
                                                                nuevos[index].esPrecioDeLoteBaseAplicado = detallesPrecio.esPrecioDeLoteBaseAplicado;
                                                                nuevos[index].esPrecioDeLoteCantidadAplicado = detallesPrecio.esPrecioDeLoteCantidadAplicado;
                                                                return nuevos;
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <p className="mb-0 text-muted">Precio unitario:</p>
                                                <div className="text-end">
                                                    {detalle.esMayoreoAplicado && !detalle.esPrecioDeLoteCantidadAplicado ? (
                                                        <div>
                                                            <span style={{ textDecoration: 'line-through', color: '#888' }}>
                                                                {formatoMoneda(detalle.precioOriginalProducto)}
                                                            </span>
                                                            <br />
                                                            <span className="text-success fw-bold">{formatoMoneda(detalle.precio)}</span>
                                                            <br />
                                                            <span className="badge bg-warning mt-1">Precio por mayor</span>
                                                        </div>
                                                    ) : detalle.esPrecioDeLoteCantidadAplicado ? (
                                                        <div>
                                                            {detalle.precioOriginalProducto && detalle.precioOriginalProducto !== detalle.precio && (
                                                                <span style={{ textDecoration: 'line-through', color: '#888' }}>
                                                                    {formatoMoneda(detalle.precioOriginalProducto)}
                                                                </span>
                                                            )}
                                                            <p className="mb-0 text-success fw-bold">{formatoMoneda(detalle.precio)}</p>
                                                            <span className="badge bg-info mt-1">Precio por cantidad</span>
                                                        </div>
                                                    ) : (
                                                        <p className="mb-0 text-success fw-bold">{formatoMoneda(detalle.precio)}</p>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center border-top pt-3">
                                                <p className="mb-0 fw-bold">Subtotal:</p>
                                                <p className="mb-0 text-success fw-bold fs-5">{formatoMoneda(detalle.subtotal)}</p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {puedeGestionarDireccion && (
                            <div className="row">
                                <div className="col-12">
                                    <label>Direcciones</label>
                                    <div className="pb-3">
                                        <GestionUbicacion
                                            direccion={nuevaDireccion}
                                            setDireccion={setNuevaDireccion}
                                            isModalOpen={isModalOpen}
                                            setIsModalOpen={setIsModalOpen}
                                            setSeleccionarDireccion={setSeleccionarDireccion}
                                            textoBoton={"Agregar dirección"}
                                            verdireccion={false}
                                            disabled={direccionesEdicion.length >= 1}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {puedeGestionarDireccion && (
                            <div className="row">
                                <div className="col-12">
                                    <label className="fw-bold">Direcciones de la cotización</label>
                                    <div className="form-group">
                                        {direccionesEdicion.length > 0 ? (
                                            direccionesEdicion.map((f, index) => (
                                                <div key={index} className="row align-items-center mb-2">
                                                    <div className="col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={f.direccion}
                                                            onChange={(e) => {
                                                                const nuevas = [...direccionesEdicion];
                                                                nuevas[index].direccion = e.target.value;
                                                                setDireccionesEdicion(nuevas);
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-4 d-flex gap-2">
                                                        <VerUbicacion direccion={f} />
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => {
                                                                const nuevas = [...direccionesEdicion];
                                                                nuevas.splice(index, 1);
                                                                setDireccionesEdicion(nuevas);
                                                            }}
                                                            title="Eliminar dirección"
                                                        >
                                                            <i className="fa fa-minus" />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-muted fst-italic">No hay direcciones agregadas aún.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                <i className="fas fa-sticky-note me-1"></i> Nota de la cotización:
                            </label>
                            <textarea
                                className="form-control border-primary rounded shadow-sm"
                                placeholder="Agregar una nota..."
                                value={notaNueva}
                                onChange={(e) => setNotaNueva(e.target.value)}
                            ></textarea>
                        </div>
                        <h5 className="me-3 mt-4">Total de la cotización: <span className="text-success">{formatoMoneda(totalCotizacion)}</span></h5>
                    </Card>
                </div>
            )}
        </Page>
    );
};
export default EditarCotizacion;